import { ChakraProvider } from '@chakra-ui/react';
import appTheme from 'presentation/theme/theme';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import router from 'router/router';
import store from 'store';

import AuthProvider from 'presentation/containers/modules/auth/AuthProvider';
import LangProvider from 'presentation/containers/modules/lang/LangProvider';
import ChatWidget from 'presentation/containers/modules/chat/ChatWidget';
import { ChatProvider } from 'presentation/components/modules/ai/ChatContext';
import AttributionTracker from 'presentation/containers/modules/attribution/AttributionTracker';

function App(): JSX.Element {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <AuthProvider>
          <LangProvider>
            <AttributionTracker />
            <ChatProvider>
              <ChakraProvider theme={appTheme}>
                <RouterProvider router={router} />
                <ChatWidget/>
              </ChakraProvider>
            </ChatProvider>
          </LangProvider>
        </AuthProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
